import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import BackToTop from "@tSurya/Components/BackToTop";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import { ELEMENTS } from "@tSurya/theme/design";
import * as React from "react";
import { ReactNode } from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

interface OwnProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

// Category urlSegments on which the breadcrumb should be hidden (per-brand via design token).
// These are the PLP "nav" landing pages that render SurSubcategoryNav (e.g. "All").
const hideBreadcrumbSegments = ((ELEMENTS.breadcrumbs as { hideOnCategorySegments?: string[] }).hideOnCategorySegments ?? []).map(segment =>
    segment.toLowerCase(),
);

const mapStateToProps = (state: CustomApplicationState) => {
    const currentCategoryUrlSegment = getCategoryState(state, state.pages.productList?.productFilters?.pageCategoryId).value?.urlSegment;
    return {
        hideBreadcrumb:
            hideBreadcrumbSegments.length > 0 && !!currentCategoryUrlSegment && hideBreadcrumbSegments.includes(currentCategoryUrlSegment.toLowerCase()),
    };
};

type PageLayoutProps = OwnProps & ReturnType<typeof mapStateToProps>;

const hiddenBreadcrumbCss = css`
    display: none;
`;

const printHiddenBreadcrumbCss = css`
    @media print {
        [data-test-selector="pageBreadcrumbs"] {
            display: none !important;
        }
    }
`;

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
    hideBreadcrumb,
}: PageLayoutProps) => {
    return (
        <PageLayoutWrapper>
            {showHeader && header}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page
                    as="div"
                    css={
                        hideBreadcrumb
                            ? css`
                                  ${hiddenBreadcrumbCss}
                                  ${printHiddenBreadcrumbCss}
                              `
                            : printHiddenBreadcrumbCss
                    }
                >
                    <PageBreadcrumbs />
                </Page>
            )}
            {pageContent}
            {showFooter && footer}
            {showSignInOverlay && signInOverlay}
            {showStorePickupOverlay && storePickupOverlay}
            {showAddressBookOverlay && addressBookOverlay}
            <BackToTop />
        </PageLayoutWrapper>
    );
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
    }

    @media print {
        display: block;
    }
`;

export default connect(mapStateToProps)(PageLayout);
